import { useSearch } from '../../../../hooks/context';
import { useCurrentLayout } from '../../../../components/context/layout';

const namespace = 'ui-search-andes-message';

const useListingDisclaimer = () => {
  const { listing_disclaimer, shops } = useSearch();
  const isShops = Boolean(shops);
  const currentLayout = useCurrentLayout();

  const layoutId = currentLayout?.id || '';

  const listingDisclaimerClassName = isShops
    ? 'shops__listing-shops__listing-disclaimer-card'
    : `${namespace}__card ${namespace}__card--${layoutId}`;

  const className = isShops ? 'shops__listing-disclaimer' : `${namespace} ${namespace}--${layoutId}`;

  return listing_disclaimer
    ? {
        ...listing_disclaimer,
        currentLayout,
        isShops,
        listingDisclaimerClassName,
        className,
        closable: false,
      }
    : { listing_disclaimer, isShops, listingDisclaimerClassName, className, closable: false };
};

export default useListingDisclaimer;
